import { PartyStatus, PartyType } from '../components/Form/Party/PartyForm'
import { ShortUserListItemDto } from './userConfig'
import { AddressDto, Gender, PersonNameDto } from './contactConfig'
import { IReferenceDto } from './fileConfig'

export type PartyRecipientDto = {
    displayName: string
    email: string
}

export type ListItemDto = PartyRecipientDto & {
    id: string
    type: PartyType
    status: PartyStatus
    displayName: string
    crmRelation?: boolean
    documentRootId?: string
}

export type PartyOverviewItemDto = ListItemDto & {
    salutation: string
    email: string
    phoneNumber: string
    identificationVerified?: boolean
    crmRelation: boolean
    accountManager?: ShortUserListItemDto
}

export type BasePartyDto = PartyOverviewItemDto & {
    shortName: string
    address?: AddressDto
    phoneLandline: string
    kycFile?: IReferenceDto
    description?: string
}

export type LegalPersonDto = BasePartyDto & {
    name: string
    legalStructure: string
    poBoxAddress?: AddressDto
    financeTermInvoice?: number
    financeTermPayment?: number
    financeEmail?: string
    vatNumber?: string
    cocNumber?: string
    reference?: string
    fileReferenceRequired?: boolean
}

export type NaturalPersonDto = BasePartyDto & {
    gender: Gender
    name: PersonNameDto
    attentionOf?: string
    phoneMobile?: string
    dateOfBirth: string
}

export enum PartyAction {
    GetOverview = 'GET_PARTY_OVERVIEW',
    GetList = 'GET_PARTY_LIST',
    Reset = 'RESET_PARTIES',
}

export function isPartyOverviewItem(party: ListItemDto | PartyOverviewItemDto): party is PartyOverviewItemDto {
    return (<PartyOverviewItemDto>party).status !== undefined
}
